function mergeInternal(source: any, target: any): void {
	let keys = (Object.keys(source));
	let i = -1;
	let l = keys.length;
	while (++i < l) {
		let key = keys[i];
		let sourceItem = source[key];
		let targetItem = target[key];
		//Prevent never-ending loop
		if (target === sourceItem) {
			continue;
		}
		const isArray = Array.isArray(sourceItem);
		if (isArray || typeof sourceItem === 'object') {
			if (targetItem == null) {
				(target[key] = targetItem = isArray ? [] : {});
			}
			mergeInternal(sourceItem, targetItem);
		} else if (targetItem == null) {
			(target[key] = sourceItem);
		}
	}
}

/**
 * Escribe sobre target lo que venga en  defaults, sólo si en target no existe la propiedad a escribir.
 * @param defaults - Los defaults a mergear.
 * @param target - El objeto destino sobre el cual se mergearán los valores.
 * @returns El objeto destino.
 */
export default function mergeObjects<T>(defaults: T | null, target: T | null): T {
	//@ts-ignore
	target ??= {};
	if (defaults == null) {
		return target!;
	}
	mergeInternal(defaults, target);
	return target!;
};
